import styled from 'styled-components';
import { Divider } from '@material-ui/core';

export const StyledDivider = styled(Divider)`
  margin: 25px 0;
  height: 1px;
`;
